module.exports = __webpack_public_path__ + "media/images/stock_groups/e56c-803f81a7cd446409372f714c65e4a3ed.svg";